class AjaxCart extends HTMLElement {
    constructor() {
      super();
      this.cartDrawer = this.querySelector('cart-drawer');
    //  this.cartIcon = document.getElementById("cart-icon-bubble");
    // this.cartIcon.addEventListener('click', this.toggle.bind(this));
      this.cartIcon2 = document.querySelectorAll(".cart-icon-bubble");
      this.cartIcon2.forEach(element => {
        element.addEventListener('click', this.toggle.bind(this));
      });

      this.headerHamburger = document.querySelector(".header__icon--menu");
      this.headerHamburger.addEventListener('click', this.headerClose.bind(this));
    //  console.log('binding events')
      this.bindEvents();
    }

    bindEvents() {
      this.cartClose = this.querySelectorAll('.cart__close');
      this.cartClose.forEach(element => {
        element.addEventListener('click', this.close.bind(this));
      });
      this.backdrop = this.querySelector('backdrop');
      this.backdrop.addEventListener('click', this.close.bind(this));
      this.swipeMove();
    }

    swipeMove() {
      let startX, startY, distX, distY
      this.querySelector('cart-drawer').addEventListener('touchstart', (e) => {
        var touchobj = e.changedTouches[0];
        startX = touchobj.pageX
        startY = touchobj.pageY
      });
      this.querySelector('cart-drawer').addEventListener('touchend', (e) => {
        var touchobj = e.changedTouches[0];
        distX = touchobj.pageX - startX
        distY = touchobj.pageY - startY;
        if(distX > 80) {
          e.preventDefault();
          this.close();
        }
      });
    }

    toggle(event) {
      event.preventDefault();
      event.stopPropagation();
      return this.hasAttribute("open") ? this.close() : this.open();
    }

    open(event) {
      this.cartDrawer.classList.add('animate', 'active');
      this.setAttribute("open", "");
      document.body.classList.add(`ajax-cart-open`);
    }

    headerClose(event) {
      if(document.body.classList.contains(`ajax-cart-open`)) {
        event.stopPropagation();
        event.preventDefault();
        this.close();
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    close() {
      this.removeAttribute("open", "");
      document.body.classList.remove(`ajax-cart-open`);
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden-tablet');
    }

    // Only needed if wishlist present
    initializeWishlistButtons() {
      if("_swat" in window) {  _swat.initializeActionButtons("#shopify-section-ajax-cart") }
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((item => {
        var section = document.getElementById(item.id);
        if(section) section.innerHTML = this.getSectionInnerHTML(parsedState.sections[item.id], item.selector);
      }));

	  this.updateCartCounter(parsedState);

      setTimeout(() => {
		  this.initializeWishlistButtons();
        this.open();
      }, 100);
      this.bindEvents();
    }

	updateCartCounter(cartState) {

		const elementCounter = document.querySelectorAll('[data-cart-counter]');
		const elementMobileCounter = document.querySelectorAll('[data-cart-counter-mobile]');

		if (elementCounter)
			elementCounter.forEach((counter => {
				 counter.innerHTML = this.getSectionInnerHTML(cartState.sections['cart-icon-bubble']);
			}));

		if (elementMobileCounter)
			elementCounter.forEach((counter => {
				counter.innerHTML = this.getSectionInnerHTML(cartState.sections['cart-icon-bubble-mobile']);
			}));
	}

    getSectionsToRender() {
      return [
        {
          id: 'ajax-cart',
          selector: `#ajax-cart`,
        },
        {
          id: 'gift-with-purchase',
          selector: '#gift-with-purchase'
        },
		{
		  id: 'cart-icon-bubble'
		},
		{
		  id: 'cart-icon-bubble-mobile'
		}
      ];
    }
  }

  customElements.define('ajax-cart', AjaxCart);
